import { z } from "zod";
import { emailSchema } from "../common/email.js";

export const requestEmailChangeSchema = z
	.object({
		new_email: emailSchema,
	})
	.strict();

export type RequestEmailChangePayload = z.infer<typeof requestEmailChangeSchema>;
